import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=52407d64&"
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"
import style0 from "./Layout.vue?vue&type=style&index=0&id=52407d64&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports